



















































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ControlButtons extends Vue {
  @Prop({ default: false }) disabled!: boolean

  mouseDown: boolean = false

  moveUp() {
    this.$emit('move', 'up')
  }

  moveDown() {
    this.$emit('move', 'down')
  }

  moveLeft() {
    this.$emit('move', 'left')
  }

  moveRight() {
    this.$emit('move', 'right')
  }
}
